import { picklist as vPicklist } from 'valibot';

export const EPC_GES_CLASS_VALUES = [`A`, `B`, `C`, `D`, `E`, `F`, `G`] as const;
export const EpcGesSchema = vPicklist(EPC_GES_CLASS_VALUES);
export type EpcGesClass = typeof EPC_GES_CLASS_VALUES[number];
export type EpcGesStatus = `available-not-required` | `available-excessive` | `available`;

export interface EpcGes {
  isAvailable: boolean
  date?: string
  epc: {
    status: EpcGesStatus
    class?: EpcGesClass
    consumption?: number
  }
  ges: {
    status: EpcGesStatus
    class?: EpcGesClass
    consumption: number
  }
  finalEnergyPerformanceConsumption?: number
  year?: number
  amount: {
    min?: number
    max?: number
    fix?: number
  }
}
